// actions.ts
import { Context, ISaveGrantPayload, ISaveAllPayload, IActions } from './actions.types'
import { RootState } from '@/store/types'
import { IGrantData, Notification, INotification, Grant, IGrant } from '@/entities'
import { ActionTree } from 'vuex';


export const actions: IActions = {
   
    /** set the grant state on selection */
    getGrant(context: Context, id: number): any {
        if(id) {
            return this.$services.grant.getGrant(id)
            .then((data: any) => {
                context.commit('setGrant', { grant: data });
                return data;
            });
        }
    },
    /** Get the grant data */
    getGrantData(context: Context, id: number): any {
        if(id) {
            return this.$services.grant.getGrantData(id)
            .then((data: any) => {
                context.commit('setGrantData', data);
                return data;
            });
        }
    },
    /** save the grant header */
    saveGrant(context: Context, payload: ISaveGrantPayload): any {
        return this.$services.grant.updateGrant(payload.id, payload.data)
            .then((data: any) => {
                if (data.Result === 'OK') {
                    context.commit('setGrant', { grant: data.Record });
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Grant saved successfully', color: 'success' } as INotification),  { root: true });         
                } else {
                    if(data.ValidationMessages && data.ValidationMessages.length > 0) {
                        context.commit('setValidationMessages', data.ValidationMessages);                    
                    } else {
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
                    }                    
                }
                
            });
    },

    /** save grant data */
    saveGrantData(context: Context, payload: ISaveGrantPayload): any {
        return this.$services.grant.updateGrantData(payload.id, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                if(!payload.hideNotification)
                    context.commit('application/setNotification', new Notification({ snack: true, text: 'Grant saved successfully', color: 'success' } as INotification),  { root: true });         
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        })
    },

    /** save grant meta & data */
    saveAll(context: Context, payload: ISaveAllPayload): any {
        return this.$services.grant.updateGrantData(payload.id, payload.data)
        .then((data: any) => {
            if (data.Result === 'OK') {
                return this.$services.grant.updateGrant(payload.id, payload.grant)
                .then((datum: any) => {
                    if (datum.Result === 'OK') {
                        context.commit('setGrant', { grant: datum.Record });
                        context.commit('application/setNotification', new Notification({ snack: true, text: 'Grant saved successfully', color: 'success' } as INotification),  { root: true });         
                    } else {
                        if(datum.ValidationMessages && datum.ValidationMessages.length > 0) {
                            context.commit('setValidationMessages', datum.ValidationMessages);                    
                        } else {    
                        context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: datum.Message, color: 'error' } as INotification),  { root: true })
                        }
                    }                    
                });
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },

    updatePPO(context: Context, payload: any): any {
        return this.$services.grant.updatePPO(payload.id, payload.ppoid)
        .then((data: any) => {
            if (data.Result === 'OK') {
                context.commit('setPPO', { grant: data.Record });
                context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'success' } as INotification),  { root: true });
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    },
    
    changeOwnership(context: Context, payload: any): any {
        return this.$services.grant.changeOwnership(payload.id, payload.userId, 'grant')
        .then((data: any) => {
            if (data.Result === 'OK') {
                // context.commit('setGrantee', { data: data.Record });
                context.commit('application/setNotification', new Notification({ snack: true, text: data.Message, color: 'success' } as INotification),  { root: true });
            } else {
                context.commit('application/setNotification', new Notification({ snack: true, isHtml: true, text: data.Message, color: 'error' } as INotification),  { root: true })
            }
        });
    }
}
